import React from "react";
import HeaderPanel from './components/HeaderPanel';
import MainPanel from './components/MainPanel';
import './App.css';

function App() {
  return (
    <div className="App">
      <HeaderPanel/>
      <MainPanel/>
    </div>
  );
}

export default App;
